import { ApplicationInsights, IConfig, IConfiguration, ITelemetryItem } from "@microsoft/applicationinsights-web";

let appInsights: ApplicationInsights = null;

const appSettings = (window as any).appSettings ?? {};

const defaultConfig: IConfig & IConfiguration = {
    connectionString: appSettings ? appSettings["APPLICATIONINSIGHTS_CONNECTION_STRING"] : undefined,
    disableFetchTracking: true,
    disableDataLossAnalysis: false,
    disablePageUnloadEvents: ["unload"],
    enableUnhandledPromiseRejectionTracking: true,
};

async function init(playerIdGetter?: () => string) {
    appInsights = new ApplicationInsights({
        config: defaultConfig,
    });

    const telemetryInitializer = (envelope: ITelemetryItem) => {
        envelope.tags["ai.cloud.role"] = "Frontend";
        envelope.tags["ai.cloud.roleInstance"] = "Frontend";
        envelope.data = envelope.data || {};
        envelope.data.playerId = playerIdGetter?.() ?? null;
        envelope.data.location = window.location.href;
        envelope.data.userAgent = window.navigator.userAgent;
        envelope.data.mobileView = environment.isInAppView;
    };

    appInsights.addTelemetryInitializer(telemetryInitializer);
    appInsights.loadAppInsights();

    if (environment.siteName === "Sazkabet") {
        appInsights.trackPageView();
    }
}

function trackEvent(name: string, properties: Record<string, any>) {
    appInsights?.trackEvent(
        {
            name: name,
        },
        {
            properties,
        }
    );
}

// Used to track exceptions with custom properties in addition to automatically tracked exceptions (other than base data).
function trackException(exception: Error, properties: Record<string, any> = {}) {
    appInsights?.trackException({ exception, properties });
}

function trackMetric(name: string, value: number) {
    appInsights?.trackMetric({ name: name, average: value });
}

function setUserContext(id: string) {
    appInsights?.setAuthenticatedUserContext(id);
}

function clearUserContext() {
    appInsights?.clearAuthenticatedUserContext();
}

export function useAppInsights() {
    return {
        init,
        trackEvent,
        trackMetric,
        trackException,
        setUserContext,
        clearUserContext,
    };
}
